import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmationDailogService } from '../company-module/shared/confirm-dailog/confirmation-dailog.service';
import { AppStateProvider } from '../services/app-state.provider';
import { SidenavService } from '../services/sidenav.service';

@Injectable({
  providedIn: 'root'
})
export class RestrictEntryGuard implements CanActivate {

  constructor(private confirmService: ConfirmationDailogService,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('parkId')) {
        return true;
      } else {
        this.confirmService.confirm('Please confirm..', 'Park is not mapped.', 'Back', false)
          .then((confirmed) => {
            const route = this.sideNavService.routingChunks({ name: 'Overview' });
            this.appStateSrv.setSideNavState(route);
            this.router.navigate([this.router.url])
          })
          .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      }
    } else {
      this.confirmService.confirm('Please confirm..', 'Session has timed out.', 'Back', false)
        .then((confirmed) => {
          const route = this.sideNavService.routingChunks({ name: 'Overview' });
          this.appStateSrv.setSideNavState(route);
          this.router.navigate([this.router.url])
        })
        .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
  }
}
